import { NavLink, useLocation } from "react-router-dom";
import "./SideNavLink.css";
import { cn } from "../../../utils/helpers";

interface SideNavLinkProps {
    href?: string;
    title: string;
    icon: React.ReactElement;
    onClick?: () => void;
    disabled?: boolean;
    count?: number;
    activePaths?: string[];
}

export default function SideNavLink({
    href,
    title,
    icon,
    onClick,
    disabled,
    count,
    activePaths,
}: SideNavLinkProps) {
    const { pathname } = useLocation();
    const isAlsoActive = activePaths?.includes(pathname) ?? false;

    if (disabled) {
        return (
            <li className="relative inline-block pt-2 w-full mb-12">
                <NavLink
                    end
                    to={href as string}
                    className="opacity-70 bg-strokelight cursor-not-allowed px-10 py-12 w-full h-40 rounded-r8 flex items-center gap-x-12 font-medium text-sm text-gray"
                >
                    {icon}
                    {title}
                </NavLink>
                <span className="absolute -top-3 border border-strokedark inline-flex items-center whitespace-nowrap text-nowrap px-8 py-[2px] rounded-full text-xs font-medium leading-[16px] bg-[var(--color-yellow-300)] text-black">
                    Coming Soon
                </span>
            </li>
        );
    }
    return (
        <li className="w-full last:mb-0 mb-12">
            <NavLink
                end={href === "/"}
                to={href as string}
                className={({ isActive }) =>
                    cn(
                        "px-10 py-12 w-full h-40 rounded-r8 flex items-center gap-x-12 font-semibold text-sm",
                        isActive || isAlsoActive
                            ? "nav-link-active"
                            : "bg-transparent text-gray nav-link-idle"
                    )
                }
                onClick={onClick}
            >
                {icon}
                <span className="flex-1">{title}</span>
                {count && count > 0 ? (
                    <span className="ml-auto flex h-20 min-w-20 items-center justify-center rounded-full bg-warning px-4 text-xss font-semibold leading-none text-black">
                        {count > 99 ? "99+" : count}
                    </span>
                ) : null}
            </NavLink>
        </li>
    );
}
